<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="banco_id" class="block text-sm font-medium text-gray-700">Nombre del banco</label>
      <select id="banco_id" :value="selectedBancoId"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              @change="(idBancoNew)=> {$emit('updateValues', {'cuenta_bancaria_id': ''}); selectedBancoId = idBancoNew.target.value}">
        <option value='' selected>Seleccione un banco...</option>
        <option v-for="(banco, index) of collectionBancos" :key="'B'+index" :value="banco.id">{{
            banco.nombre_banco
          }}
        </option>
      </select>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="cuenta_bancaria_id" class="block text-sm font-medium text-gray-700">Cuenta bancaria</label>
      <select id="cuenta_bancaria_id" :value="loadData.cuenta_bancaria_id"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              @change="(idCuentaBancariaNew)=>$emit('updateValues', {'cuenta_bancaria_id': customUpdateValueData('cuenta_bancaria_id', idCuentaBancariaNew.target.value)})">
        <option value="" selected>Seleccione una cuenta bancaria...</option>
        <option v-for="(cuentaBancaria, index) of collectionCuentasBancarias.filter(cuentaBancaria => cuentaBancaria.banco.id === selectedBancoId)" :key="'B'+index" :value="cuentaBancaria.id">
          {{ `${cuentaBancaria.cuenta_bancaria} (${cuentaBancaria.nombre_cuenta})`}}
        </option>
      </select>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="tasa_efectiva_anual" class="block text-sm font-medium text-gray-700">Tasa efectiva anual</label>
      <input type="number" step="0.01" id="tasa_efectiva_anual" :value="loadData.tasa_efectiva_anual"
              @change="(tasaEfectivaAnualNew)=>$emit('updateValues', {'tasa_efectiva_anual': customUpdateValueData('tasa_efectiva_anual', tasaEfectivaAnualNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      <small class="text-gray-500 font-bold w-full block">- El maximo de enteros permitidos es de 3.</small>
      <small class="text-gray-500 font-bold w-full block">- El maximo de decimales permitidos es de 10.</small>
      <small class="text-gray-500 font-bold w-full block">- Los números con decimales deben ir separados por un
        punto.</small>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="tasa_representativa" class="block text-sm font-medium text-gray-700">Tasa representativa</label>
      <input type="number" step="0.01" id="tasa_representativa" :value="loadData.tasa_representativa"
              @change="(tasaRepresentativaNew)=>$emit('updateValues', {'tasa_representativa': customUpdateValueData('tasa_representativa', tasaRepresentativaNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      <small class="text-gray-500 font-bold w-full block">- El maximo de enteros permitidos es de 3.</small>
      <small class="text-gray-500 font-bold w-full block">- El maximo de decimales permitidos es de 10.</small>
      <small class="text-gray-500 font-bold w-full block">- Los números con decimales deben ir separados por un
        punto.</small>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="year" class="block text-sm font-medium text-gray-700">Año</label>
      <input type="number" step="1" min="1920" id="year" :value="loadData.year"
              @change="(yearNew)=>$emit('updateValues', {year: customUpdateValueData('year', yearNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="mes" class="block text-sm font-medium text-gray-700">Mes</label>
      <select :value="loadData.mes"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              @change="(mesNew)=>$emit('updateValues', {'mes': customUpdateValueData('mes', mesNew.target.value)})">
        <option value="" selected>Seleccione un mes...</option>
        <option v-for="(nameMonth, key, index) in monthNames()" :value="parseInt(key)+1" :key="'C'+index">
          {{ nameMonth }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import {monthNames} from "@/common/constants";

export default {
  name: "TasasEACrearActualizarComponent",
  data: function() {
    return {
      selectedBancoId: ''
    }
  },
  methods: {
    monthNames() {
      return monthNames
    }
  },
  props: ['loadData', 'collectionBancos', 'collectionCuentasBancarias', 'customUpdateValueData'],
  emits: ["updateValues"],
  watch: {
    collectionCuentasBancarias: {
      handler(newCollectionCuentasBancarias) {
        if(this.loadData.cuenta_bancaria_id)
          this.selectedBancoId = newCollectionCuentasBancarias.filter(cuentaBancaria => cuentaBancaria.id === this.loadData.cuenta_bancaria_id.toString())[0].banco.id
      },
      deep: true
    }
  },
}
</script>